import Vue from 'vue'
import { mapGetters } from 'vuex'

Vue.mixin({
  data() {
    return {

    }
  },
  computed: {
    // 选中的语言
    ...mapGetters([ 'langCountry' ]),
    pc_lang() {
      return this.lang[this.langCountry]
    },
    /* 交易状态 */
    dealStatus() {
      return [
        {
          id: '',
          words: this.pc_lang.All
        },
        {
          id: 0,
          words: this.pc_lang.Processing
        },
        {
          id: 1,
          words: this.pc_lang.Pending_payment
        },
        {
          id: 2,
          words: this.pc_lang.Successful_transaction
        },
        {
          id: 3,
          words: this.pc_lang.Refunding
        },
        {
          id: 4,
          words: this.pc_lang.refunded
        },
        {
          id: 5,
          words: this.pc_lang.Shipped
        },
        {
          id: 6,
          words: this.pc_lang.Transaction_failed
        }
      ]
    },
    /* 交易类型 */
    dealType() {
      return [
        {
          id: '',
          words: this.pc_lang['All']
        },
        {
          id: 1,
          words: this.pc_lang['Top_up']
        },
        {
          id: 2,
          words: this.pc_lang['Withdraw']
        },
        {
          id: 3,
          words: this.pc_lang['Fund_Transfer']
        },
        {
          id: 4,
          words: this.pc_lang['Refund']
        },
        {
          id: 5,
          words: this.pc_lang['Order_payment']
        },
        {
          id: 6,
          words: this.pc_lang['Collect_Fund']
        },
        {
          id: 7,
          words: this.pc_lang['Commission_Withdraw']
        },
        {
          id: 8,
          words: this.pc_lang['Credited_Amount']
        },
        {
          id: 9,
          words: this.pc_lang['Auto_Debit']
        }
      ]
    },
    /* 交易方式 */
    dealWay() {
      return [
        {
          id: 0,
          words: this.pc_lang.Balance
        },
        {
          id: 1,
          words: this.pc_lang.Alipay
        },
        {
          id: 2,
          words: this.pc_lang.WeChat
        },
        {
          id: 3,
          words: this.pc_lang.FPX
        },
        {
          id: 4,
          words: this.pc_lang.Credit_card
        },
        {
          id: 5,
          words: this.pc_lang.Billplz
        }
      ]
    }
  },
  methods: {

  }
})
